<script setup>

import { computed, defineProps } from 'vue';
import { dateUtils } from '@/util/dateUtil';
const dayjs = require('dayjs')

const props = defineProps({
    shift: Object,
    department: Object
})

const isManual = computed(() => {
    return props.shift.Position == "Manual Entry"
})

const isFuture = computed(() => {
    return dayjs(props.shift.Start) > dayjs()
})

const statusDisplay = computed(() => {
    let stat = ""
    if (isFuture.value) {
        stat = "Future"
    }
    else {
        switch (props.shift.Status) {
            case "ok":
                stat = "Worked"
                break
            default:
                stat = "No Show"
                break
        }
    }
    return stat
})

const actualWorked = computed(() => {
    return props.shift.Status == "ok" ? props.shift.HoursWorked : 0
})
</script>

<template>
    <v-row class="shift-item">
        <v-col>
            <div>
                <span class="dept-name"><strong>{{ shift.Department }}</strong></span>
                <br> {{ shift.Position }}
            </div>

            <span v-if="!isManual">
                {{ dateUtils.shiftTime(shift.Start, shift.End) }}
            </span>
        </v-col>
        <v-col class="text-right">
            <div>Status: {{ statusDisplay }}</div>
            <div v-show="!isFuture">Hours Worked: {{ actualWorked }}</div>
            <div>Weight: {{ shift.Weight }}</div>
        </v-col>
    </v-row>
</template>

<style scoped>
.shift-item {
    margin-top: 0;
}

.dept-name {
    font-size: 1.1em;
}
</style>